import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import FeedbackCard from './FeedbackCard';

interface FormData {
  name: string;
  dateOfIncident: string;
  position: string;
  department: string;
  supervisor: string;
  dateOfHire: string;
  policyViolationIds: string[];
  descriptionOfFeedback: string;
  immediateFeedback: string;
  expectationForImprovement: string;
  emailOfFeedback: string;
}

interface PolicyViolation {
  id: string;
  name: string;
}

interface FeedbackSummaryProps {
  isOpen: boolean;
  toggle: () => void;
  submittedForms: Map<string, FormData>;
  policyViolations: PolicyViolation[];
  onBackToEdit: () => void;
  onSubmit: (approved: boolean) => void;
  isSubmitting: boolean;
}

const FeedbackSummary = ({
  isOpen,
  toggle,
  submittedForms,
  policyViolations,
  onBackToEdit,
  onSubmit,
  isSubmitting,
}: FeedbackSummaryProps) => {
  const getPolicyViolationNames = (violationIds: string[]) => {
    return violationIds
      .map((id) => {
        const violation = policyViolations.find((v) => v.id === id);
        return violation ? violation.name : 'Unknown Policy';
      })
      .join(', ');
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="xl" style={{ maxWidth: '1200px' }}>
      <ModalHeader toggle={toggle}>Feedback Summary</ModalHeader>
      <ModalBody style={{ maxHeight: '70vh', overflowY: 'auto' }}>
        <div className="mb-4">
          <h5 className="text-primary mb-3">Review all feedback forms before submitting</h5>
          <div
            style={{
              maxHeight: '50vh',
              overflowY: 'auto',
              border: '1px solid #dee2e6',
              borderRadius: '4px',
              padding: '15px',
            }}
          >
            {Array.from(submittedForms.entries()).map(([userId, formData], index) => (
              <FeedbackCard
                key={userId}
                index={index}
                name={formData.name}
                dateOfIncident={formData.dateOfIncident}
                position={formData.position}
                department={formData.department}
                supervisor={formData.supervisor}
                policyViolation={getPolicyViolationNames(formData.policyViolationIds)}
                immediateFeedback={formData.immediateFeedback}
                emailOfFeedback={formData.emailOfFeedback}
                descriptionOfFeedback={formData.descriptionOfFeedback}
                expectationForImprovement={formData.expectationForImprovement}
              />
            ))}
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onBackToEdit} disabled={isSubmitting}>
          <i className="fas fa-arrow-left mr-2" />
          Back to Edit
        </Button>
        <div className="ml-auto">
          <Button color="warning" onClick={() => onSubmit(false)} disabled={isSubmitting} className="mr-2">
            {isSubmitting ? (
              <>
                <i className="fas fa-spinner fa-spin mr-2" />
                Saving...
              </>
            ) : (
              <>
                <i className="fas fa-save mr-2" />
                Save Draft
              </>
            )}
          </Button>
          <Button color="primary" onClick={() => onSubmit(true)} disabled={isSubmitting}>
            {isSubmitting ? (
              <>
                <i className="fas fa-spinner fa-spin mr-2" />
                Submitting...
              </>
            ) : (
              <>
                <i className="fas fa-paper-plane mr-2" />
                Submit All Forms
              </>
            )}
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default FeedbackSummary;
